import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import jwtDecode from 'jwt-decode'
import { useQueryClient } from '@tanstack/vue-query'

import * as MaCookieStorage from '@/model/MaCookieStorage'
import { accountQueryKey } from '@/api/services/account'

export const useAuthStore = defineStore('auth', () => {
  const queryClient = useQueryClient()

  const userAuth = ref(MaCookieStorage.get(MaCookieStorage.COOKIES.AUTH))
  const isCompleteIntegrationFlow = ref(false)
  const impersonatorUsername = ref(MaCookieStorage.get(MaCookieStorage.COOKIES.IMPERSONATOR_USERNAME))

  const jwt = computed(() => userAuth.value?.jwt ?? '')

  const refreshToken = computed(() => userAuth.value?.refreshToken ?? '')

  const jwtData = computed(() => jwt.value ? jwtDecode(jwt.value) : {})

  const refreshTokenData = computed(() => refreshToken.value ? jwtDecode(refreshToken.value) : {})

  const setUserAuth = (authInfo) => {
    MaCookieStorage.set(MaCookieStorage.COOKIES.AUTH, authInfo, 30, MaCookieStorage.AUTH_COOKIE_OPTIONS)
    userAuth.value = MaCookieStorage.get(MaCookieStorage.COOKIES.AUTH)

    if (authInfo) {
      queryClient.refetchQueries({
        queryKey: accountQueryKey.fetchUserInfo(),
      })
    }
  }

  const setImpersonatorUsername = (username) => {
    MaCookieStorage.set(MaCookieStorage.COOKIES.IMPERSONATOR_USERNAME, username, 7, MaCookieStorage.AUTH_COOKIE_OPTIONS)
    impersonatorUsername.value = MaCookieStorage.get(MaCookieStorage.COOKIES.IMPERSONATOR_USERNAME)
  }

  const updateJWT = (token) => {
    userAuth.value.jwt = token
    setUserAuth(userAuth.value)
  }

  const $reset = () => {
    setUserAuth(null)
    setImpersonatorUsername(null)
    isCompleteIntegrationFlow.value = false
  }

  return {
    userAuth,
    isCompleteIntegrationFlow,
    impersonatorUsername,
    jwt,
    refreshToken,
    jwtData,
    refreshTokenData,
    setUserAuth,
    setImpersonatorUsername,
    updateJWT,
    $reset,
  }
})
